/* eslint-disable @nx/enforce-module-boundaries */
import { Inject, Injectable } from '@angular/core';
import { BaseUploadImage } from 'admin-drivers/src/app/utils/Base-Upload-Image';
import { UploadImageResponse } from 'admin-drivers/src/app/utils/models/UploadImageResponse';
import { Environment } from '@t-llevo/util';
import { forkJoin, map } from 'rxjs';
import { apiRoutes } from '../../api-routing'

@Injectable()
export class UploadImageService extends BaseUploadImage<UploadImageResponse> {
  constructor(@Inject(Environment) private env: Environment) {
    super();
  }

  uploadDriverImage(file: File) {
    const url = this.env.apiUrl + apiRoutes.routeUploadDriverImage;
    return this.uploadImage({ file, url }).pipe(
      map((obs) => {
        const data = obs.data.replace(
          'public/drivers/',
          `${this.env.apiUrl}files/managefiles/drivers/`
        );
        return { ...obs, data };
      })
    );
  }

  uploadLicenseImage(file: File) {
    const url = this.env.apiUrl + apiRoutes.routeUploadLicenseImage;
    return this.uploadImage({ url, file }).pipe(
      map((obs) => {
        const data = obs.data.replace(
          'public/licences/',
          `${this.env.apiUrl}files/managefiles/licences/`
        );
        return { ...obs, data };
      })
    );
  }

  uploadLicensesImages(files: File[]) {
    const request = files.map((file) => this.uploadLicenseImage(file));
    return forkJoin(request);
  }

  uploadVehicleTypeImage(file: File) {
    const url = this.env.apiUrl + apiRoutes.routeUploadVehicleTypeImage;
    return this.uploadImage({ file, url }).pipe(
      map((obs) => {
        const data = obs.data.replace(
          'public/typevehicles/',
          `${this.env.apiUrl}files/managefiles/typevehicles/`
        );
        return {...obs, data}
      })
    );
  }

  getImageByUrl(url: string) {
    return this.getImage(url);
  }

  getImagesByUrls(urls: string[]) {
    return this.getImages(urls);
  }
}
